var lazySizes = require('../../vendors/lazysizes/lazysizes.min');
var parallax = require('./parallax-effect');
var Dialog = require("./dialog");

$('.lazyload').on('error', function (e) {
    $(e.target).data('load-error', true);
});

$(document).on('lazyloaded', 'img', function (e) {
    var $target = $(e.target);

    if ($target.data('load-error')) {
        // if the image could not be loaded, leave the inline styles intact to preserve the layout
        e.preventDefault();
        return;
    }

    if ($target.data('ws-aspect-ratio-applied')) {
        // if we used the aspect-ratio styling hack for the placeholder, we need to clear it now that the real image has been loaded
        e.target.style.height = '';
        e.target.style.width = '';
        e.target.style.maxWidth = '';
        e.target.style.paddingTop = '';
    } else {
        // if the aspect-ratio hack wasn't used, then we may need to reapply the match-height plugin on the containing match-height target
        var $matchHeightTarget = $target.parents('.ws-mh-target');
        if ($matchHeightTarget.length && $matchHeightTarget.matchHeight) {
            $matchHeightTarget.matchHeight._update();
        }
    }
});

// try to preload images if the user tries to print the page
if ('onbeforeprint' in window) {
    var printEventListener = function () {
        window.removeEventListener('beforeprint', printEventListener);
        unveilAllChildren();
    };

    window.addEventListener('beforeprint', printEventListener);
} else if (window.matchMedia) {
    var mediaQueryList = window.matchMedia('print');

    var mediaQueryListener = function (mql) {
        if (mql.matches) {
            mediaQueryList.removeListener(mediaQueryListener);
            unveilAllChildren();
        }
    };

    mediaQueryList.addListener(mediaQueryListener);
}

function unveilAllChildren($parent) {
    $parent = $parent || $('body');
    $parent.find('.lazyload').each(function (index, element) {
        lazySizes.loader.unveil(element);
    });
}

function unveilAll($el) {
    $el = $el || $('body');
    $el.each(function (index, element) {
        lazySizes.loader.unveil(element);
    });
}

exports.unveilAllChildren = unveilAllChildren;
exports.unveilAll = unveilAll;
window.WS = window.WS || {};
window.WS.lazySizes = exports;